/**
 * Returns an array of matches that have exactly two contestants.
 *
 * Safely traverses the nested data structure and filters out any
 * matches that don't have a `contestant` array of length 2.
 *
 * @param {Object} data - The data object containing the matches.
 * @returns {Array} An array of matches with two contestants.
 */
const getContestedMatches = (data) => {
  const matches = data?.matches?.matches?.match;

  if (!Array.isArray(matches)) return [];

  return matches.filter((match) => match?.matchInfo?.contestant?.length === 2);
};

export default getContestedMatches;
